module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('Player', {
    ref: "player",
    attrs: {
      "url": _vm.mediaSrc,
      "subtitles": _vm.data,
      "playAt": _vm.currentSentIdx
    },
    on: {
      "video": _vm.updateMediaState
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobileDevice),
      expression: "isMobileDevice"
    }],
    staticClass: "text-center p-5"
  }, [_vm._v("\n    此功能不支援行動裝置。\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobileDevice),
      expression: "!isMobileDevice"
    }]
  }, [_c('div', {
    staticClass: "p-2",
    attrs: {
      "id": "recorder"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-start p-2"
  }, [_c('div', [(!(_vm.isRecordSingle || _vm.isRecordAll || _vm.playMine || _vm.media.state === 'playing')) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.playMyRoles()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_play.png"),
      "height": "35"
    }
  })]) : _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.stopAll()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_pause.png"),
      "height": "35"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.recordStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'active': _vm.isRecordSingle
    },
    on: {
      "click": function($event) {
        _vm.isRecordSingle = true;
        _vm.recordStatus = '請選擇句子'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_1_avatar.png")
    }
  }), _vm._v(" 單句\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'active': _vm.isRecordAll && _vm.userRole === null
    },
    on: {
      "click": function($event) {
        return _vm.recordAll()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_2_avatar.png")
    }
  }), _vm._v(" 全部\n          ")]), _vm._v(" "), (_vm.roles && _vm.roles.length > 1) ? _c('popper', {
    ref: "rolePopper",
    attrs: {
      "trigger": "click",
      "options": {
        placement: 'bottom'
      }
    }
  }, [_c('div', {
    staticClass: "popper"
  }, _vm._l((_vm.roles), function(role) {
    return _c('button', {
      key: role,
      staticClass: "btn",
      class: {
        'active': _vm.isRecordAll && _vm.userRole === role
      },
      on: {
        "click": function($event) {
          _vm.$refs.rolePopper.doClose() || _vm.recordAll(role)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/images/icon_1_avatar.png")
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(role)
      }
    })])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'active': _vm.isRecordAll && _vm.userRole
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_1_avatar.png")
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s((_vm.isRecordAll && _vm.userRole) ? _vm.userRole : '角色扮演')
    }
  })])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('Sentences', {
    attrs: {
      "texts": _vm.data,
      "lang": ['en_us'],
      "currentTime": _vm.media.currentTime
    },
    on: {
      "selectSentId": _vm.singleSent
    },
    scopedSlots: _vm._u([{
      key: "leftside",
      fn: function(props) {
        return [(props.row.no === (_vm.currentSentIdx + 1)) ? _c('span', [(_vm.recording) ? _c('i', {
          staticClass: "fa fa-microphone blink"
        }) : _vm._e(), _vm._v(" "), (_vm.media && _vm.media.state === 'playing') ? _c('i', {
          staticClass: "fa fa-play-circle blink"
        }) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "rightside",
      fn: function(props) {
        return [(_vm.audioList.map(function (e) {
          return e.name
        }).indexOf(props.row.text) > -1) ? _c('span', {
          staticClass: "btn",
          staticStyle: {
            "font-size": "8px"
          },
          on: {
            "click": function($event) {
              return _vm.playRecord(props.row.no - 1)
            }
          }
        }, [(props.row.no === (_vm.media.currentSentIdx + 1) && (_vm.audio && !_vm.audio.paused)) ? _c('img', {
          class: {
            'blink': props.row.no === (_vm.media.currentSentIdx + 1) && (_vm.audio && !_vm.audio.paused)
          },
          attrs: {
            "src": require("../assets/images/icon_headphone_on.png")
          }
        }) : _c('img', {
          attrs: {
            "src": require("../assets/images/icon_headphone_off.png")
          }
        }), _vm._v(" "), _c('br'), _vm._v("\n              " + _vm._s(_vm.moment(_vm.audioList[_vm.audioList.map(function (e) {
          return e.name
        }).indexOf(props.row.text)].createtime).fromNow()) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._t("left")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59d337de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Recorder.vue
// module id = 787
// module chunks = 3